import { classNames } from "../../../utils/common";
import PropTypes from "prop-types";

const sizes = {
  xs: { height: 24, width: 24 },
  sm: { height: 32, width: 32 },
  md: { height: 48, width: 48 },
  lg: { height: 64, width: 64 },
  xl: { height: 96, width: 96 },
  '2xl': { height: 128, width: 128 },
  '3xl': { height: 192, width: 192 },
  '4xl': { height: 256, width: 256 },
};

const Spin = ({color, size = 'xs', strokeWidth = '4', hasInnerCircle}) => {
  return (
    <>
      <svg
        className={classNames("animate-spin -ml-1 h-5 w-5")}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        style={sizes[size] || sizes['xs']}
      >
        <circle
          className={hasInnerCircle ? "opacity-25" : 'opacity-0'}
          cx="12"
          cy="12"
          r="10"
          stroke={color || "currentColor"}
          strokeWidth={strokeWidth || '4'}
          ></circle>
        <circle
          className={'opacity-95'}
          cx="12"
          cy="12"
          r="10"
          stroke={color || "currentColor"}
          strokeWidth={strokeWidth || '4'}
          strokeDasharray={'200%'}

          ></circle>
        {/* <path
          className="opacity-95"
          fill={color || "currentColor"}
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path> */}
      </svg>
    </>
  );
};

Spin.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  strokeWidth: PropTypes.string,
  hasInnerCircle: PropTypes.bool,
}

export default Spin;